import React from 'react';
import { BASE_URL } from '../Api';

class ThankYou extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            link: `${BASE_URL}/releases/latest/Aronium.${props.version}.Setup.exe`,
            isPro: props.version === 'Pro'
        };
    }

    componentDidMount() {
        setTimeout(() => this.startDownload(), 1000);
    }

    startDownload() {
        const link = document.createElement('a');
        link.href = this.state.link;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        return <section className='max-w-screen-xl mx-auto text-center p-4'>
            <h1 className='text-5xl mt-8 tracking-tighter'>Thank you for downloading Aronium {this.props.version}!</h1>

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-32 h-32 mx-auto mt-8 text-green-600">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>

            <div className='my-8'>
                Your download will begin shortly. If it does not, please use the <a href={this.state.link}>direct download link</a>.
            </div>
            <hr className='md:w-48 mx-auto' />
            <h1 className='text-4xl my-8'>What's next?</h1>
            {this.state.isPro && <div className="my-8">
                <a href={`https://help.aronium.com/hc/en-us/articles/30156389965458-Setting-up-Aronium-Pro?utm_campaign=download-page&utm_medium=link&utm_source=website`} className="hover:no-underline inline-flex items-center justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-full bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 mr-2"><path d="M22 6h-6v-6l6 6zm-8 2v-8h-12v24h20v-16h-8z"/></svg>
                    Read setup instructions
                </a>
            </div>}
            <div className='my-4 mx-auto text-center'>
                <p>Visit our <a href="http://help.aronium.com" target="_blank" rel="noreferrer">support center</a> for tutorials and more information.</p>
                <p>If you have any questions, feel free to <a href='/contact'>contact us</a> anytime.</p>
            </div>
        </section>
    };
}

export default ThankYou;